<template>
    <page>
        <module :title="id ? '编辑素材' : '添加素材'">
            <c-form ref="form">
                <c-form-item type="select" label="素材分类" name="type_id" options="MEDIA_CATALOG_TYPE_ID" required></c-form-item>
                <c-form-item type="hidden" label="关联商品ID" name="product_id"></c-form-item>
                <c-form-item type="textarea" label="素材内容" name="content" maxlength="1000" word="素材内容最多输入1000个字符"></c-form-item>
                <c-form-item type="image" label="素材图片" name="img_url" oss limit="9" word="素材图片大小建议不超过3MB，最多上传9张(图片、视频不能同时为空)" :inline-word="false"></c-form-item>
                <c-form-item type="video" label="商品视频" name="video_url" oss file-word="视频格式：MP4<br>视频支持1:1，16:9，视频文件建议不超过30M(图片、视频不能同时为空)"></c-form-item>
                <c-form-item label="关联商品">
                    <c-button v-if="!productInfo" style="margin: 5px 0;" @click="$refs.productSelector.open()">选择商品</c-button>
                    <c-button v-if="productInfo" color="red" style="margin: 5px 0;" @click="removePrduct()">删除商品</c-button>
                    <div v-if="productInfo" class="flex">
                        <c-image :src="productInfo.product_img_url" size="100"></c-image>
                        <p style="width: 350px; margin-top: 10px; margin-left: 18px; line-height: 20px; font-size: 13px; color: #444;">{{productInfo.product_name}}</p>
                        <span slot="word" style="color:darkgray">
                            素材-商品只能1对1关联，请选择尚未关联其他素材的商品
                        </span>
                    </div>
                </c-form-item>
                <c-form-item type="radio" label="状态" name="state" v-model="state" :options="stateArray" required></c-form-item>
            </c-form>

            <template slot="button">
                <c-button power="b_media_catalog_edit" size="m" @click="submit()">提交发布</c-button>
            </template>
        </module>

        <product-selector ref="productSelector" @resolve="productSelectHandle"></product-selector>
    </page>
</template>

<script>
    import productSelector from '@/components/service/product_selector.vue'

    export default {
        name: 'media_catalog_edit',

        components: {
            productSelector
        },

        props: {
            id: String
        },

        data() {
            return {
                productInfo:undefined,
                state:2,
                stateArray: [
                    {name: '启用',value: 2},
                    {name: '禁用',value: 1}
                ]
            }
        },

        computed: {

        },

        watch: {
            id() {
                this.getDetail();
            },
        },

        mounted() {
            if (this.id) {
                this.getDetail();
            }
        },

        methods: {
            getDetail() {
                this.request({
                    url:'media/catalog/detail',
                    data: {
                        id: this.id
                    },
                    loading: true,
                    success: data => {
                        this.$refs.form.set(data);
                        if (data.product_id && data.product_id > 0){
                            this.productInfo = {
                                product_name: data.product_name,
                                product_img_url: data.product_img_url
                            }
                        }
                    }
                });
            },

            //选择商品（回调）
            productSelectHandle(data) {
                this.$refs.form.set({
                    product_id: data[0].product_id
                });
                this.productInfo = {
                    product_name: data[0].product_name,
                    product_img_url: data[0].product_img_url
                }
            },

            //删除商品
            removePrduct(){
                this.$refs.form.set({
                    product_id: 0
                });
                this.productInfo = undefined;
            },

            submit(type) {
                this.$refs.form.submit({
                    url: this.id?'/media/catalog/edit':'/media/catalog/add',
                    rule: {
                        type_id: [{
                            type: 'empty',
                            word: '请选择素材分类'
                        }],
                        img_url: [{
                            type: 'empty',
                            word: '素材图片、素材视频不允许同时为空',
                            skip: (data) => {
                                return (data.img_url&&data.img_url.length > 0) || data.video_url
                            }
                        }],
                        video_url: [{
                            type: 'empty',
                            word: '素材图片、素材视频不允许同时为空',
                            skip: (data) => {
                                return (data.img_url&&data.img_url.length > 0) || data.video_url
                            }
                        }]
                    },
                    dataFormatter: data => {
                        // 提交前处理数据格式
                        if(this.id){
                            data.id = this.id;
                        }
                        return data;
                    },
                    success: () => {
                        this.$message({
                            text: '保存成功'
                        });
                        //跳转回到素材库列表
                        this.$bus.$emit('mediaCatalog.update', {});
                        this.redirectTo('/media/catalog/list');
                    }
                });
            }
        }
    }
</script>

<style lang="stylus" scoped>
  .box {
    background: #F9F8FB;
  }

  .params {
    box-sizing: border-box;
    width: 1000px;
    padding: 25px 20px 25px 45px;
  }

  .detail {
    padding: 15px;

    &-preview {
      width: 370px;
      border: 1px solid #ddd;
      margin-right: 30px;
      background: #fff;

      dt {
        border-bottom: 1px solid #ddd;
        line-height: 40px;
        font-size: 13px;
        font-weight: bold;
        text-indent: 12px;
      }

      dd {
        height: 560px;
        overflow: auto;
        font-size: 0;

        img {
          width: 100%;
          max-height: initial;
        }
      }
    }

    &-edit {
      .tips {
        line-height: 40px;
        font-size: 12px;
        color: #666;

        b {
          font-weight: bold;
          color: #f00;
        }
      }
    }
  }

  .spec {
    position: relative;
    padding: 15px 17px;
    margin-bottom: 16px;

    &-list {
      box-sizing: border-box;
      width: 1000px;
      border: 1px dotted #ddd;
      padding: 14px;
    }

    &-label {
      margin-right: 8px;
      line-height: 36px;
      font-size: 13px;
      white-space: nowrap;
      color: #444;
    }

    &-remove {
      position: absolute;
      right: 0;
      top: 0;
      width: 24px;
      line-height: 24px;
      font-size: 12px;
      text-align: center;
      color: #fff;
      background: #aaa;

      &:hover {
        background: #999;
      }
    }

    &-name {
      width: 130px;
      height: 34px;
      border: 1px solid #ddd;
      padding: 0 10px;
      margin-right: 14px;
      font-size: 13px;
      background: #fff;
    }

    .c-checkbox {
      margin-top: 0;
    }

    &-item {
      width: 128px;
      height: 30px;
      border: 1px solid #ddd;
      padding: 0 5px;
      margin-top: 12px;
      margin-right: 12px;
      background: #fff;

      &-img {
        margin-right: 5px;
        width: 25px;
        height: 25px;
        color: #bbb;
        background: #F5F5F5;
        cursor: pointer;
      }

      &-value {
        font-size: 13px;
      }

      &-remove {
        margin-left: 5px;
        font-size: 16px;
        color: #C70000;
      }
    }

    .c-button {
      margin-top: 12px;
    }
  }

  .sku-detail {
    position: relative;

    .batch-set {
      position: absolute;
      left: 0;
      top: -90px;
      padding: 0 11px 17px;
      background: #fff;
      box-shadow: 0 0 4px 0 rgba(0, 0, 0, .2);

      p {
        line-height: 43px;
        font-size: 13px;
        font-weight: bold;
      }

      input {
        width: 100px;
        height: 28px;
        border: 1px solid #ddd;
        padding: 0 5px;
        margin-right: 5px;
      }
    }

    table {
      width: 1000px;

      thead {
        background: #F9F9F9;
      }

      tbody {
        background: #fff;
      }

      th, td {
        width: 100px;
        height: 40px;
        line-height: 40px;
        border: 1px solid #ddd;
        color: #444;
        font-size: 12px;
        text-align: left;
        padding: 0 10px;
      }

      th {
        b {
          margin-right: 5px;
          color: #f00;
        }

        a {
          margin-left: 5px;
        }
      }

      td {
        input {
          width: 100%;
          height: 100%;
          border: none;
        }

        .image {
          position: relative;
          width: 28px;
          height: 28px;
          border: 1px dotted #ccc;
          font-size: 12px;
          color: #ccc;
          cursor: pointer;

          &:hover {
            border-color: #999;
            color: #999;

            a {
              display: block;
            }
          }

          a {
            display: none;
            position: absolute;
            left: 0;
            right: 0;
            line-height: 28px;
            text-align: center;
            color: #fff;
            background: rgba(0, 0, 0, .7);
          }
        }
      }
    }
  }
</style>
